<template>
    <div class="container">
        <div class="forget-password">
            <h1 class="page_h1">忘記密碼</h1>
            <div class="form f-row">
                <formInupt label="手機號碼" v-model="req.phone" :error="error.phone" />
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn w:full clr:primary" @click="onclick">繼續</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import formInupt from '../../../components/form/input.vue'
import Validator from "../../../libs/Validator";
import Response from "../../../libs/Response";

export default {
    name: 'forget-password',
    components: {
        formInupt,
    },
    data(){
        return {
            req:{
                phone:'',
            },
            error:{
                phone:'',
            },
        }
    },
    methods:{
        async onclick(){
            const vm = this
            try{
                const validator = Validator.make(vm.req,{
                    phone:['required','min:10','max:10','phone']
                })
                if (validator.fails()) {
                    console.log(validator._errors)
                    throw Response.create(validator.errors())
                }
                this.$store.commit('setLoadingStatus',true)
                const res = await vm.$axios.post('/api/forget_password', vm.req);
                this.$store.commit('setLoadingStatus',false)
                vm.$router.push({name:'enter_verify_code',params:{token:res.data.token}});

            }catch (e) {
                this.$store.commit('setLoadingStatus',false)
                vm.error = e.response.data
            }

        }
    },
}
</script>

<style lang="scss" scoped>
.login_title {
    margin-bottom: 20px;
}
.router_link {
    font-size: 0.875rem;
}
</style>
